import { Grid, styled } from '@mui/material';
import isEmpty from 'lodash-es/isEmpty';
import { useState } from 'react';
import { IJob } from 'wisestep-api';
import {
  WsButton,
  WsTypography,
  WsTypoVariants,
  EmptyTeamsAndUsersIcon,
  WsTypoColors,
  WsListingLoader,
} from 'wisestep-base';

// import useSimilarJobs from '../../hooks/useSimilarJobs';
import NoDataFoundCard from '../../../../../components/noDataFoundCard/NoDataFoundCard';
import { getLocation } from '../../../../../features/candidates/utils/CandidateHelper';
import { openUrlInNewTab } from '../../../../../utils/openUrlInNewTab';
import useSimilarJobsFromJobSearch from '../../hooks/useSimilarJobsFromJobSearch';
import useSimilarJobStore from '../../hooks/useSimilarJobStore';

const DrawerFooter = styled(Grid)(() => ({
  position: 'fixed',
  bottom: 1,
  width: '12vw',
  textAlign: 'center',
  right: '5px',
  justifyContent: 'flex-end',
}));

type ViewDetailsDrawerProps = {
  job: IJob;
};

const SimilarJobsModel = ({ job }: ViewDetailsDrawerProps) => {
  // const [similarJobsData] = useSimilarJobs(job);
  const setSimilarJobs = useSimilarJobStore((state) => state.setSimilarJobs);
  const [loader, setLoader] = useState<boolean>(false);
  const similarJobsFromJobSearch = useSimilarJobsFromJobSearch(job, setLoader);

  const getJobIdAndCodeArray = (jobs) =>
    JSON.stringify({
      jobIds: jobs.map((job) => job.id ?? ''),
      jobCodes: jobs.map((job) => job.jobCode ?? ''),
    });

  const setSimilarJobsAllCandidates = () => {
    setSimilarJobs(similarJobsFromJobSearch);

    openUrlInNewTab(
      `/candidates/mappings/similarJobs/${encodeURI(
        getJobIdAndCodeArray(similarJobsFromJobSearch)
      )}`
    );
  };

  const setSimilarJobCandidatesForJob = (job: IJob) => {
    setSimilarJobs([job]);
    openUrlInNewTab(`/candidates/mappings/similarJobs/${encodeURI(getJobIdAndCodeArray([job]))}`);
  };
  return (
    <>
      {!isEmpty(similarJobsFromJobSearch) ? (
        similarJobsFromJobSearch.map((similarJob, index) => (
          <Grid key={index} container p={2} display="flex" justifyContent="space-between">
            <Grid item xs={9}>
              <WsTypography variant={WsTypoVariants.TITLE}>
                {`${similarJob.title} ${similarJob.jobCode}`}
              </WsTypography>
              {similarJob?.locations?.length &&
                similarJob?.locations?.map((location, index) => {
                  if (index >= 2) return null; // Skip rendering beyond the first two locations
                  return (
                    <WsTypography variant={WsTypoVariants.SUB_TITLE} key={index}>
                      {getLocation(location)}
                    </WsTypography>
                  );
                })}
            </Grid>
            <Grid item xs={3} display="flex" justifyContent="flex-end">
              <WsButton variant="text" onClick={() => setSimilarJobCandidatesForJob(similarJob)}>
                View Candidates
              </WsButton>
            </Grid>
          </Grid>
        ))
      ) : loader ? (
        <WsListingLoader />
      ) : (
        <Grid container sx={{ position: 'absolute', width: '100%' }}>
          <NoDataFoundCard
            text={'Oops! No similar jobs found for the Job.'}
            icon={<EmptyTeamsAndUsersIcon />}
            subElement={
              <Grid container p={4}>
                <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.SECONDARY}>
                  Tip: To discover similar jobs to your current posting, we recommend providing a
                  clear job description, adding more relevant skills, and specifying the accurate
                  location. This will help you find candidates who are better matched to the job
                  more effectively.
                </WsTypography>
              </Grid>
            }
          />
        </Grid>
      )}
      <DrawerFooter>
        {similarJobsFromJobSearch?.length > 0 && (
          <Grid container item justifyContent="right" alignItems="right" py={1}>
            <WsButton variant="contained" onClick={setSimilarJobsAllCandidates}>
              View All Candidates
            </WsButton>
          </Grid>
        )}
      </DrawerFooter>
    </>
  );
};
export default SimilarJobsModel;
